import { Injectable, WritableSignal, effect } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { StreamingChatRequest } from '../../../../../backend/src/core/openai/openai.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { WebSocketGate } from '../../../../../backend/src/core/websocket/websocket.gate';
import { OpenaiMessage } from '../openai/openai';
import { BoardHolderService } from './../board/board.holder.service';
import { UserClerkService } from './../user/user-clerk.service';
import { WorkspaceHolderService } from './../workspace/workspace.holder.service';
import { WebSocketBackend } from './websocket';

@Injectable({
  providedIn: 'root',
})
export class WebSocketSendService {
  constructor(
    private msg: NzMessageService,
    private router: Router,
    private userClerkService: UserClerkService,
    private workspaceHolderService: WorkspaceHolderService,
    private boardHolderService: BoardHolderService
  ) {
    effect(() => {
      if (this.isConnected && this.isConnected()) {
        if (this.webSocket?.readyState === 1) {
          this.payloadList.forEach((message) => {
            this.webSocket?.send(JSON.stringify(message));
          });
          this.payloadList = [];
        }
      }
    });
  }

  webSocket?: WebSocket;
  isConnected?: WritableSignal<boolean>;

  init(webSocket: WebSocket, isConnected: WritableSignal<boolean>) {
    this.webSocket = webSocket;
    this.isConnected = isConnected;
  }

  sendStreamingChat(
    coreId: string,
    messageList: OpenaiMessage[],
    config?: { model?: string; temperature?: number; additionalId?: string | number }
  ) {
    const request: StreamingChatRequest = {
      coreId,
      additionalId: config?.additionalId,
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      personalBoardId: this.boardHolderService.myPersonalBoard()?.id ?? '',
      messageList,
      config: {
        model: config?.model,
        temperature: config?.temperature,
      },
    };
    this.sendPayload(WebSocketGate.actions.sendStreamingChat, request);
  }

  setLocation(location: { currentCoreItemId?: string }) {
    const webSocketBackend: Partial<WebSocketBackend> = {
      currentWorkspaceId: this.workspaceHolderService.currentWorkspace().id,
      personalBoardId: this.boardHolderService.myPersonalBoard()?.id ?? '',
      currentBoardId: this.boardHolderService.myPersonalBoard()?.id ?? '', // TODO: No other board supports now.
      currentCoreItemId: location.currentCoreItemId,
    };

    this.sendPayload(WebSocketGate.actions.setLocation, webSocketBackend);
  }

  payloadList: any[] = [];

  sendPayload(action: string, payload: any) {
    if (!payload.currentWorkspaceId && !payload.workspaceId) {
      return;
    }

    if (!this.userClerkService.getUser()) {
      return this.router.navigate(['/login']);
    }

    const message = {
      headers: {
        resource: ResourceName.websocket,
        action,
        accessToken: '',
      },
      payload,
    };

    if (this.webSocket?.readyState == 1) {
      this.webSocket?.send(JSON.stringify(message));
    } else {
      this.payloadList.push(message);
    }
    return;

    // return this.userClerkService.getAccessToken$().pipe(
    //   map((accessToken) => {
    //     console.log('----- sendPayload:', accessToken);

    //     if (!accessToken) {
    //       return this.router.navigate(['/login']);
    //     }

    //     const message = {
    //       headers: {
    //         resource: ResourceName.websocket,
    //         action,
    //         accessToken,
    //       },
    //       payload,
    //     };

    //     console.log(
    //       '----- this.webSocket?.readyState:',
    //       this.webSocket?.readyState,
    //     );

    //     if (this.webSocket?.readyState == 1) {
    //       this.webSocket?.send(JSON.stringify(message));
    //     } else {
    //       this.payloadList.push(message);
    //     }
    //     return;
    //   }),
    // );
  }
}
